<template>
	<div id="service1">
		<Menu areWeinServices="true" selectedRoute="execProtection"/>
		<!-- Header Inicio :style="{ backgroundImage: 'url(' + firstImage + ')' }" -->
		<div class="colorAzul">
			<section class="secImage1">
				<div class="fondotransparenteServicio">
					<h1>{{title}}</h1>
				</div>
			</section>

			<section class="secTexto">
				<div class="textoContenidoInterno">
					<div class="html">
						<!--
						<h1 class="tituloContenidoInterno">
							<span>{{subtitle}}</span>
						</h1>
						-->
						<h2 class="subtituloContenidoInterno">
							<span>We keep high value targets working or traveling in Mexico Safe and Comfortable</span>
						</h2>

						<p class="parrafoContenidoInterno">
							We offer a wide range of services for transportation and protection of corporate executive personnel, VIPs, CEOs, senior executives, and celebrities traveling or living in Mexico, including:
						</p>
						<ul class="listaContenidoInterno">
							<li>Risk analysis, logistics and route planning</li>
							<li>Rapid Response Center 24x7x365</li>
							<li>GPS Tracking</li>
							<li>Bilingual drivers trained in evasive driving</li>
							<li>Bilingual security agents</li>
							<li>Armed security guards</li>
							<li>Armored executive vehicles</li>
							<li>Escort vehicles</li>
						</ul>
						<p class="parrafoContenidoInterno">
							<span>Glarus Group</span> develops tailored solutions that meet the needs and lifestyle
							of key people in your organization.
							<br>
							<br>We work hand-in-hand with local authorities, airport authorities, and the security departments of major hotels.
						</p>
					</div>

					<!-- Aqui va el componente PopServices -->

					<cuadro/>

					<!-- cuadro -->
				</div>
			</section>

			<section class="secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
				<div class="fondoAzulServiciosGrid">
					<h1 class="headGridServices">
						<span>{{titleIcons}}</span>
					</h1>

					<div class="gridIcons">
						<div class="precautions" v-for="item in precautions" :key="item.id">
							<span>
								<img :src="item.icon" :alt="item.altIcon">
							</span>
							<h3>{{ item.descripcion }}</h3>
						</div>
					</div>
				</div>
			</section>
		</div>

		<FooterComponent areWeinServicesFooter="true"/>
	</div>
</template>

<script>
// @ is an alias for /src
import Menu from "@/components/Menu2.vue";
import cuadro from "@/components/PopEachService.vue";
import FooterComponent from "@/components/Footer.vue";

//Imagenes del servicio
import imagen1 from "@/assets/img/servicios/1_seguridad.jpg";
import imagen2 from "@/assets/img/servicios/1/second_.jpg";
import icono01 from "@/assets/img/servicios/1/01.png";
import icono02 from "@/assets/img/servicios/1/02.png";
import icono03 from "@/assets/img/servicios/1/03.png";
import icono04 from "@/assets/img/servicios/1/04.png";

export default {
	name: "execProtection",
	components: {
		Menu,
		cuadro,
		FooterComponent
	},
	mounted: function() {
		this.$nextTick(function() {
			document.title =
				"Glarus Group - Executive Transportation and Protection in Mexico";
		});
	},
	data: function() {
		return {
			title: "EXECUTIVE TRANSPORTATION AND PROTECTION IN MEXICO",
			// subtitle: "Executive transportation and protection",
			// thirdTitle: "Security and experience in executive mobility services.",
			firstImage: imagen1,
			secondImage: imagen2,
			titleIcons: "We Provide",

			precautions: [
				{
					id: "4",
					icon: icono04,
					altIcon: "glarus service 4",
					descripcion: "Risk Analysis, Logistics and Route Planning"
				},
				{
					id: "1",
					icon: icono01,
					altIcon: "glarus service 1",
					descripcion: "Trained Bilingual Drivers and Security Agents"
				},
				{
					id: "2",
					icon: icono02,
					altIcon: "glarus service 2",
					descripcion: "Armored Executive Vehicles and Escort Vehicles"
				},
				{
					id: "3",
					icon: icono03,
					altIcon: "glarus service 3",
					descripcion: "Rapid Response Center 24x7x365"
				}
			]
		};
	}
};
</script>

<style lang="less" scoped>
@import url("../../assets/less/soloVariables.less");
@import url("../../assets/less/cssServiciosComponent.less");
</style>
